import { Modal } from "@fourkites/elemental-modal"
import { useTranslation } from "react-i18next"
import { langOptions } from "./languageState"
import i18n from "./config"
import { useDispatch } from "react-redux"

const LanguageModal = (props: any) => {
  const { onClose } = props
  const dispatch = useDispatch()
  const onLanguageSelect = (lang: any) => {
    dispatch({ type: "language/CHANGE_LANGUAGE", language: lang })
    localStorage.setItem("i18nLocalStorageKey", lang.value)
    i18n.changeLanguage(lang.value)
    onClose()
  }
  const { t } = useTranslation()
  return (
    <Modal
      title=""
      customHeader={
        <div className="header-container">
          <span>{t("select_language")}</span>

          <span className="close-icon" onClick={() => onClose()}>
            X
          </span>
        </div>
      }
      show={true}
      size="large"
    >
      <div className="modal-container">
        {langOptions.map(option => (
          <div
            key={`lang-${option.value}`}
            style={{
              padding: 20,
              borderBottom: `1px solid "#dee2e6"`,
              fontSize: 16,
              cursor: "pointer"
            }}
            onClick={() => onLanguageSelect(option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default LanguageModal
